import React, { useCallback } from "react";
import { NormalizedDescriptionInfo } from "@common/types/normalizedDescription";
import { RuleGroupType, TransactionRule } from "@common/types/transactionRule";
import { ModalComponentProps } from "@helpers/modal";
import { useUpdateRule } from "@api/rules.api";
import {
    RuleForm,
    TransactionRuleSubmitData,
} from "./TransactionRuleForm/RuleForm";
import { TransferRuleForm } from "./TransferRuleForm/TransferRuleForm";

interface Props extends ModalComponentProps {
    rule: TransactionRule;
    groupType: RuleGroupType;
    normalizedDescriptions?: NormalizedDescriptionInfo[];
}

export const EditRuleModal: React.FC<Props> = ({
    rule,
    close,
    groupType,
    normalizedDescriptions,
}) => {
    const updateRule = useUpdateRule(close);

    const onEdit = useCallback(
        async (data: TransactionRuleSubmitData) => {
            await updateRule.mutateAsync({
                rule: data.rule,
                ruleId: rule.id,
                workspaceId: rule.workspaceId,
                applyToExistingTransactions: data.applyToExistingTransactions,
                excludedTransactionsIds: data.excludedTransactionsIds,
                includedTransactionsIds: data.includedTransactionsIds,
            });
        },
        [updateRule, rule],
    );

    if (groupType === RuleGroupType.TRANSFER) {
        return (
            <TransferRuleForm
                rule={rule}
                onSubmit={onEdit}
                isSubmitting={updateRule.isPending}
                submitText="Update Rule"
            />
        );
    } else {
        return (
            <RuleForm
                rule={rule}
                onSubmit={onEdit}
                isSubmitting={updateRule.isPending}
                submitText="Update rule"
                normalizedDescriptions={normalizedDescriptions}
            />
        );
    }
};
